import _extends from "@babel/runtime/helpers/esm/extends";
import * as React from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
var Cursor04 = function Cursor04(props) {
  return /*#__PURE__*/_jsx("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props, {
    children: /*#__PURE__*/_jsx("path", {
      stroke: "currentColor",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2,
      d: "M4.407 3.414c-.4582-.1347-.6874-.2021-.8434-.144a.5.5 0 0 0-.2938.2939c-.0582.156.0092.3851.144.8434l4.2059 14.3c.1252.4259.1879.6388.3143.7376a.5.5 0 0 0 .3898.0994c.1583-.0262.3152-.1832.629-.497L12 16.0002l4.4344 4.4343c.198.198.297.297.4111.3341a.5.5 0 0 0 .3091 0c.1141-.0371.2131-.1361.4111-.3341l2.8687-2.8686c.198-.198.297-.297.3341-.4112a.5.5 0 0 0 0-.309c-.0371-.1142-.1361-.2132-.3341-.4112L16 12.0002l3.0471-3.047c.3139-.314.4708-.4709.4971-.6292a.5.5 0 0 0-.0994-.3898c-.0989-.1264-.3118-.189-.7376-.3143z"
    })
  }));
};
export default Cursor04;